import classNames from 'classnames';
import React from 'react';

import commonStyles from '../../../common.module.scss';

import image from './monetization.png';

export const MonetizationVariant: React.FC = () => (
  <div>
    <img
      className={commonStyles.image}
      src={image}
      alt="Illustration of a future webpage-builder feature"
    />
    <h2 className={commonStyles.h2}>
      Sell your creations with ease thanks to pay-to-download links
    </h2>
    <p className={commonStyles.body}>
      With WeTransfer, you could get paid from the same place you send your
      files.
    </p>
    <ul className={classNames(commonStyles.body, commonStyles.list)}>
      <li>Send transfers and receive payments with the same link</li>
      <li>Require payment before files are downloaded</li>
      <li>Keep track of payments in one simple overview</li>
    </ul>
    <p className={commonStyles.body}>
      While we’re cooking up this new idea, we’d love to hear from you.
    </p>
  </div>
);

MonetizationVariant.displayName = 'MonetizationVariant';
